export const IssueIcon = () => (
	<svg
		fill="none"
		height="16"
		viewBox="0 0 16 16"
		width="16"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="issue"
	>
		<path
			d="m5 7.875 2 2.375 4-4.75m-9 7.75h12c.6904 0 1.25-.5596 1.25-1.25v-8c0-.69036-.5596-1.25-1.25-1.25h-12c-.69036 0-1.25.55964-1.25 1.25v8c0 .6904.55964 1.25 1.25 1.25z"
			stroke="#4688ec"
			strokeLinejoin="round"
			strokeWidth="1.5"
		/>
	</svg>
);
